import PortfolioPage from "./PortfolioPage";

export default function MoreBrideStoriesPage() {
  return (
    <PortfolioPage
      pageType="more-bride-stories"
      title="More Bride Stories"
      subtitle="A beautiful journey of love and celebration"
    />
  );
}
